import { FC, lazy } from 'react';
import { PageSpinner } from 'src/components/spinner-container';
import { useFeatureFlags } from 'src/hooks/use-feature-flags';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { useMyUserDetails } from 'src/pages/settings/profile/use-my-user-details';

const Page = lazy(() => import('src/pages/settings/profile/page'));

export const Profile: FC = () => {
  const featureFlags = useFeatureFlags();

  if (featureFlags.userInvitations) return <LoadOrganisationService />;

  return <Page />;
};

const LoadOrganisationService: FC = () => {
  const organisationService = useOrganisationService();
  const myUserDetails = useMyUserDetails({ organisationService });

  if (!myUserDetails.response) return <PageSpinner />;

  return <Page myUserDetails={myUserDetails} />;
};
